export var emulateClickWhenEnterOrSpacePressed = function (event, target) {
    if (event.code === "Enter" /* KeyboardCode.Enter */ || event.code === "Space" /* KeyboardCode.Space */) {
        target.click();
    }
};
